import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getApprovalSettings = createAsyncThunk('approvals/getApprovalSettings', async (payload, thunkAPI) => {
  const { key, limit, page = 1 } = payload;

  let mainUrl = `/admin/approval-settings?limit=${limit}&page=${page}`;

  if (key) {
    mainUrl += `&key=${key}`;
  }

  try {
    const response = await axiosInstance.get(mainUrl);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const getApprovalSettingDetail = createAsyncThunk('approvals/getApprovalSettingDetail', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/approval-settings/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const getAllApprovalData = createAsyncThunk('approvals/getAllApprovalData', async (payload, thunkAPI) => {
  const { limit = 10, page = 1 } = payload;

  try {
    const response = await axiosInstance.get(`/approvals?limit=${limit}&page=${page}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const getApprovalDataById = createAsyncThunk('approvals/getApprovalDataById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/approvals/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const updateApprovalStatus = createAsyncThunk('approvals/updateApprovalStatus', async (payload, thunkAPI) => {
  const { id, status, skip } = payload;

  try {
    const response = await axiosInstance.put(`/approvals/${id}`, {
      status,
      skip,
    });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const updateApprovalOrder = createAsyncThunk('orders/updateApprovalOrder', async (payload, thunkAPI) => {
  try {
    const res = await axiosInstance.post(`/admin/approvals`, { ...payload });

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
